import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "liga-float-bar music-folder-float-bar" }
const _hoisted_2 = { class: "liga-float-title-pill" }
const _hoisted_3 = { class: "liga-float-title-text" }
const _hoisted_4 = {
  class: "liga-float-circle music-folder-offline-done",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 1,
  class: "liga-float-spacer",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "folder-meta-bar" }
const _hoisted_7 = { class: "duration-badge" }
const _hoisted_8 = { class: "library-download-progress" }
const _hoisted_9 = { class: "library-download-actions" }
const _hoisted_10 = {
  key: 0,
  class: "library-download-current-file ion-text-center"
}
const _hoisted_11 = {
  key: 0,
  class: "library-download-file-index"
}
const _hoisted_12 = { class: "music-list-scroll" }
const _hoisted_13 = { class: "track-number" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "track-info" }
const _hoisted_16 = { class: "track-name" }
const _hoisted_17 = { class: "track-duration" }
const _hoisted_18 = { class: "track-actions" }
const _hoisted_19 = { class: "play-button-wrapper" }
const _hoisted_20 = {
  key: 0,
  class: "ion-padding ion-text-center empty-tracks-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header liga-float-header music-library-folder-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "music-folder-float-toolbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "liga-float-circle",
                  "aria-label": "Назад",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.chevronBackOutline }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.folderTitle || 'Музыка'), 1)
                ]),
                (_ctx.showOfflineActions && !_ctx.downloadProgressBar.downloading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.folderOffline)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "liga-float-circle",
                            "aria-label": "Сохранить офлайн",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveOffline && _ctx.saveOffline(...args)))
                          }, [
                            _createVNode(_component_ion_icon, { icon: _ctx.cloudDownloadOutline }, null, 8, ["icon"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", _hoisted_4, [
                              _createVNode(_component_ion_icon, { icon: _ctx.cloudDone }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "liga-float-circle",
                              "aria-label": "Удалить из офлайна",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmRemoveFolderOffline && _ctx.confirmRemoveFolderOffline(...args)))
                            }, [
                              _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                            ])
                          ], 64))
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background-dark music-library-folder-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.musicList))), 1)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ion_button, {
                fill: "outline",
                class: "library-download-cancel",
                onClick: _ctx.stopLibraryMusicDownload
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Отмена ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_text, { class: "library-download-meta ion-text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.downloadProgressBar.downloaded) + " Мб", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_text, { class: "library-download-hint ion-text-center" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Не закрывайте окно до завершения загрузки", -1)
                ]))]),
                _: 1
              })
            ]),
            (_ctx.downloadProgressBar.currentFileLabel)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  (_ctx.libraryDownloadFilePosition)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.libraryDownloadFilePosition), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.downloadProgressBar.currentFileLabel), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_progress_bar, {
              value: _ctx.libraryDownloadProgressValue,
              type: "determinate",
              class: "library-download-progress-bar"
            }, null, 8, ["value"])
          ], 512), [
            [_vShow, _ctx.downloadProgressBar.downloading]
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ion_list, {
              class: "bg-transparent music-library-track-list",
              lines: "none"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (audioTrack, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: audioTrack.id,
                    class: _normalizeClass(["music-item music-library-track-item", { playing: _ctx.isTrackRowActive(idx) }]),
                    onClick: ($event: any) => (_ctx.selectTrack(idx))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        (!_ctx.isTrackRowActive(idx))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(idx + 1), 1))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              icon: _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                              class: "playing-icon"
                            }, null, 8, ["icon"]))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.mediaUtils.getTrackName(audioTrack)), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.mediaUtils.formatTime(audioTrack.duration)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.showOfflineActions)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!audioTrack.isOffline)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    fill: "clear",
                                    class: "track-offline-btn",
                                    disabled: _ctx.downloadProgressBar.downloading,
                                    "aria-label": "Сохранить трек офлайн",
                                    onClick: _withModifiers(($event: any) => (_ctx.saveTrackOffline(audioTrack)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.cloudDownloadOutline,
                                        slot: "icon-only"
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.cloudDone,
                                      class: "offline-icon"
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      class: "track-offline-btn track-remove-offline-btn",
                                      disabled: _ctx.downloadProgressBar.downloading,
                                      "aria-label": "Удалить трек из офлайна",
                                      onClick: _withModifiers(($event: any) => (_ctx.confirmRemoveTrackOffline(audioTrack)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.trashOutline,
                                          slot: "icon-only"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ], 64))
                            ], 64))
                          : (audioTrack.isOffline)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                icon: _ctx.cloudDone,
                                class: "offline-icon"
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.isTrackRowActive(idx) && _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                            class: "play-icon"
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            (!_ctx.musicList.length && !_ctx.tracksLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.emptyTracksHint), 1))
              : _createCommentVNode("", true),
            (_ctx.tracksLoading)
              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                  key: 1,
                  class: "ion-margin tracks-spinner",
                  name: "crescent"
                }))
              : _createCommentVNode("", true),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fake-footer" }, null, -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}